// extracted by mini-css-extract-plugin
export default {"footer":"layout-footer_footer__vZDA8","footerCondition":"layout-footer_footerCondition__CwgpP"};